module.exports = __webpack_public_path__ + "static/img/Sección_Eureka_4_pruébala gratis.9616b204.png";